import uiLabelsPaths from '../services/uiFieldLabelsDictionary';

export const dictionariesTypesEnum = {
  productVer: 'PRODUCT_VERSION',
  enclosure: 'ENCLOSURE',
  productLevel: 'PRODUCT_LEVEL',
  chademo: 'CHADEMO_CABLE',
  productType: 'PRODUCT_TYPE',
  country: 'COUNTRY',
  owner: 'OWNER',
  maintainer: 'MAINTAINER',
  supervisor: 'SUPERVISOR',
  customers: 'CUSTOMERS',
  fieldNaming: 'FIELD_NAMING',
  failures: 'fault',
  plazas: 'PLAZAS',
  fwPackages: 'fwPackages',
  telemetryMetrics: 'telemetryMetrics',
};

// Existing dictionaries schema with parent fields
export const dictionariesSchema = [
  {
    name: dictionariesTypesEnum.enclosure,
    field: 'c_technical_information.c_enclosure',
    parent: null,
    label: 'Enclosures',
  },
  {
    name: dictionariesTypesEnum.productType,
    field: uiLabelsPaths.p_type,
    parent: null,
    label: 'Product Types',
  },
  {
    name: dictionariesTypesEnum.productVer,
    field: 'c_technical_information.c_product_version',
    parent: uiLabelsPaths.p_type,
    label: 'Product Versions',
  },
  {
    name: dictionariesTypesEnum.country,
    field: 'c_identity.c_country',
    parent: null,
    label: 'Countries',
  },
  {
    name: dictionariesTypesEnum.productLevel,
    field: 'c_technical_information.c_product_level',
    parent: null,
    label: 'Product Levels',
  },
  {
    name: dictionariesTypesEnum.chademo,
    field: 'c_technical_information.c_chademo_cable',
    parent: null,
    label: 'CHAdeMO Cables',
  },
  {
    name: dictionariesTypesEnum.owner,
    field: 'c_exploitation_info.c_owner',
    parent: null,
    label: 'Owners',
  },
  {
    name: dictionariesTypesEnum.maintainer,
    field: 'c_exploitation_info.c_maintainer',
    parent: null,
    label: 'Maintainers',
  },
  {
    name: dictionariesTypesEnum.supervisor,
    field: 'c_exploitation_info.c_supervisor',
    parent: null,
    label: 'Supervisors',
  },
  {
    name: dictionariesTypesEnum.fieldNaming,
    field: 'field_naming',
    parent: null,
    label: 'Field Mapping',
  },
  {
    name: dictionariesTypesEnum.failures,
    field: 'failures',
    parent: null,
    label: 'Faults',
  },
];

export default dictionariesTypesEnum;
